<div class="box info-box">
  <h3>Ihr {{ organisation().customFields['amountLabel'] || 'Beitrag' }}</h3>
  <p>
    Name: <span class="text--bold">{{ name() }} </span>
  </p>
  <p>
    Fälligkeitsdatum: <span class="text--bold">{{ dueDate() | date: 'd.M.yyyy' }}</span>
  </p>
  <p>
    {{ organisation().customFields['customerNumberLabel'] || 'Kundennummer' }}:
    <span class="text--bold">{{ customerNumber() }}</span>
  </p>
  <hr />
  <p>
    {{ organisation().customFields['totalAmountLabel'] || 'Gesamtbeitrag' }}:
    <span class="text--bold">{{ amountInEuro() | currency: 'EUR' : 'code' : '1.2-2' }}</span>
  </p>
</div>
